import React from 'react'
import { Tooltip } from 'antd'
import Condition from "./Condition"
import { QuestionCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

export default (props) => {
    const {
        isFit,
        partners,
        activeKey,
        conditions = [],
        addCondition,
        isMultiFrames,
        removeRecord,
        onChangeSchedules,
        handleDragEnd,
        onAddSizeFrames,
        sizeFrames,
        scheduleItem,
        onChangeRecord,
    } = props

    return <table className="ListCondition">
        <thead>
            <tr className="Head">
                <th></th>
                <th>Điều kiện</th>
                <th></th>
                <th>Thông tin lô</th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
            <tr className="SubHead">
                <th></th>
                <th>
                    {
                        !isMultiFrames ? 'Số item tối thiểu' : 'Lưới'
                    }
                    <span className="text-danger ml-1">*</span>
                </th>
                {!isMultiFrames && <th>Số item tối đa <span className="text-danger">*</span></th>}
                <th>Partner <span className="text-danger">*</span></th>
                {!isMultiFrames && <th>Min <Tooltip title='Số item tối thiểu trong 1 lô'><QuestionCircleOutlined className='ml-2 cursor-pointer' /></Tooltip></th>}
                <th>Max <Tooltip title='Số item tối đa trong 1 lô'><QuestionCircleOutlined className='ml-2 cursor-pointer' /></Tooltip></th>
                <th>Người tạo <span className="text-danger">*</span><Tooltip title="Tiền tố của 'Người tạo lô'"><QuestionCircleOutlined className='ml-2 cursor-pointer' /></Tooltip></th>
                <th>Enable</th>
            </tr>
        </thead>
        <DragDropContext onDragEnd={(result) => handleDragEnd(scheduleItem.idx, result, "conditions", activeKey)}>
            <Droppable droppableId="frames-list" direction="vertical">
                {(provided) => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                        {
                            !!conditions.length && conditions.map((cd, i) => {
                                return <Condition
                                    key={i}
                                    conditions={conditions}
                                    condition={cd}
                                    index={i}
                                    partners={partners}
                                    removeRecord={removeRecord}
                                    onChangeSchedules={onChangeSchedules}
                                    isFit={isFit}
                                    activeKey={activeKey}
                                    isMultiFrames={isMultiFrames}
                                    onAddSizeFrames={onAddSizeFrames}
                                    sizeFrames={sizeFrames}
                                    onChangeRecord={onChangeRecord}
                                    scheduleItem={scheduleItem}
                                />
                            })
                        }
                        <tr>
                            {
                                !isMultiFrames &&
                                <>
                                    <td></td>
                                    <td></td>
                                </>
                            }
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <PlusCircleOutlined onClick={() => addCondition(scheduleItem.idx, activeKey)} style={{ marginLeft: '30px' }} />
                                </div>
                            </td>
                        </tr>
                        {provided.placeholder}
                    </tbody>
                )}
            </Droppable>
        </DragDropContext>
    </table>
}